"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSaleorStat = exports.isOnfleetStat = exports.isZoeeStat = exports.isWarehouseStats = void 0;
var yup = require("yup");
var Order_1 = require("./Order");
var hotOrderSchema = yup.object().shape({
    orderNumber: yup.string().required(),
    onfleetTaskId: yup.string().required(),
    fulfillmentStatus: yup.string().required(),
    deliveryStatus: yup.string().required(),
    pickingStatus: yup.string().optional(),
    createdAt: yup.number().required(),
    unassignedTime: yup.number().optional(),
    assignedAt: yup.number().optional(),
    packedAt: yup.number().optional(),
    deliveredAt: yup.number().optional(),
    cancelledAt: yup.number().optional(),
    pickerName: yup.string().optional(),
    riderName: yup.string().optional(),
    shippingMethod: yup.string().optional(),
    shippingAddress: Order_1.addressSchema.optional(),
});
var zoeeSchema = yup.object().shape({
    warehouseId: yup.string().required(),
    inDeliveryOrdersNum: yup.number().required(),
    packingOrdersNum: yup.number().required(),
    waitingOrdersNum: yup.number().required(),
    deliveredTodayOrdersNum: yup.number().required(),
    delivered24hOrdersNum: yup.number().required(),
    avgPackingTime24hMs: yup.number().required(),
    avgPackingTime10OrdersMs: yup.number().required(),
    avgTotalTime24hMs: yup.number().required(),
    avgTotalTime10OrdersMs: yup.number().required(),
});
var saleorSchema = yup.object().shape({
    warehouseId: yup.string().required(),
    unfulfilledOrdersNum: yup.number().required(),
    fulfilledOrdersNum: yup.number().required(),
    cancelledOrdersNum: yup.number().required(),
});
var onfleetSchema = yup.object().shape({
    warehouseId: yup.string().required(),
    completedTasksNum: yup.number().required(),
    activeTasksNum: yup.number().required(),
    assignedTasksNum: yup.number().required(),
    unassignedTasksNum: yup.number().required(),
    avgTaskCompletionDurationMs: yup.number().required(),
    avgPickingDurationMs: yup.number().required(),
});
var warehouseStatsSchema = yup.object().shape({
    id: yup.string().required(),
    shortName: yup.string().optional(),
    name: yup.string().optional(),
    countryId: yup.string().required(),
    pickupAddress: yup.string().optional(),
    onfleet: onfleetSchema.required(),
    saleor: saleorSchema.required(),
    zoee: zoeeSchema.required(),
    hotOrders: yup.array().of(hotOrderSchema).required(),
});
function isWarehouseStats(obj) {
    return warehouseStatsSchema.isValidSync(obj);
}
exports.isWarehouseStats = isWarehouseStats;
function isZoeeStat(obj) {
    return zoeeSchema.isValidSync(obj);
}
exports.isZoeeStat = isZoeeStat;
function isOnfleetStat(obj) {
    return onfleetSchema.isValidSync(obj);
}
exports.isOnfleetStat = isOnfleetStat;
function isSaleorStat(obj) {
    return saleorSchema.isValidSync(obj);
}
exports.isSaleorStat = isSaleorStat;
